import { createSlice } from '@reduxjs/toolkit';
import { BREEZE_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
import { SALES_COPILOT_ASSISTANT } from '../../components/assistants/internal/constants/assistants';
import { resumeSalesCopilotThread } from '../../threads/actions/resumeSalesCopilotThread';
// TODO - remove this reducer and put customCopilotId within the chat reducer
// Having this separate assistants reducer causes gaps in connection with the current chat/thread state + added complexity to our state management that isn't necessary
// Ideally the extra info (i.e. welcomeMessage, type, name) can live in DFC with the customCopilotId living in the chat reducer being the only source of truth of what assistant is active
const initialState = {
  type: BREEZE_COPILOT,
  name: '',
  id: undefined,
  welcomeMessage: ''
};
const assistantsSlice = createSlice({
  name: 'assistants',
  initialState,
  reducers: {
    updateAssistantType: (state, action) => {
      state.type = action.payload;
    },
    updateAssistant: (state, action) => {
      state.name = action.payload.name;
      state.type = action.payload.type;
      state.id = action.payload.id;
      state.welcomeMessage = action.payload.welcomeMessage;
    }
  },
  extraReducers: builder => {
    builder.addCase(resumeSalesCopilotThread.fulfilled, () => {
      return SALES_COPILOT_ASSISTANT;
    });
  }
});
export const {
  updateAssistantType,
  updateAssistant
} = assistantsSlice.actions;
export default assistantsSlice.reducer;